import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetBlogByIdQuery } from '../../Redux/Api/AuthApi';
import './BlogDetail.css';

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetBlogByIdQuery(id);

  if (isLoading) {
    return <div className="loading">Loading blog post...</div>;
  }

  if (error || !data) {
    return (
      <div className="error-container">
        <h2>Blog post not found</h2>
        <button onClick={() => navigate(-1)}>Go Back</button>
      </div>
    );
  }

  const { title, content, category, image, createdAt, author } = data;

  const formattedDate = new Date(createdAt).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <div className="blog-detail-container">
      {/* Cover Image */}
      {image?.secure_url && (
        <div className="blog-cover">
          <img src={image.secure_url} alt={title} />
        </div>
      )}

      <div className="blog-content-wrapper">
        {/* Header */}
        <div className="blog-header">
          {category && <span className="blog-category">{category}</span>}
          
          <h1 className="blog-title">{title}</h1>
          
          <div className="blog-meta">
            {author && <span className="author">By {author}</span>}
            <span className="date">{formattedDate}</span>
          </div>
        </div>

        {/* Content */}
        <div 
          className="blog-body prose prose-invert max-w-none"
          dangerouslySetInnerHTML={{ __html: content }}
        />

        {/* Footer */}
        <div className="blog-footer">
          <button onClick={() => navigate(-1)} className="back-btn">
            ← Back to Blogs
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;